import { Overview } from 'modules/trainings/components/TrainingDetail/Overview'

export default function OverviewPage() {
  return <Overview />
}
